var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3141 27.3138C21.0657 33.5622 10.9351 33.5622 4.68665 27.3138C-1.56173 21.0654 -1.56173 10.9347 4.68665 4.6863C4.6889 4.6863 19.0653 0.438363 25.3137 6.68674C31.5621 12.9351 27.3184 27.3094 27.3141 27.3138Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3132 27.3137C33.5616 21.0654 33.5616 10.9347 27.3132 4.68624C21.0649 -1.56219 10.9342 -1.56213 4.68579 4.68624L27.3132 27.3137Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.182 20.1837C19.5248 20.4419 18.7611 20.4145 18.0985 20.0427C16.9279 19.3857 16.51 17.8986 17.1672 16.7277L16.9677 16.6159C18.9721 16.1326 20.4551 14.3132 20.4291 12.1662C20.4129 10.8314 19.8165 9.63719 18.8836 8.82007L17.4228 10.3167C17.975 10.7568 18.3331 11.4319 18.3423 12.1915C18.3585 13.534 17.2796 14.6394 15.9372 14.6556L15.94 14.8842C14.5192 13.3901 12.2022 13.0155 10.3559 14.1115C9.20802 14.793 8.47215 15.9065 8.23083 17.1231L10.2573 17.6399C10.3624 16.9416 10.768 16.2939 11.4211 15.9061C12.5756 15.2208 14.0723 15.6026 14.7576 16.7569L14.9544 16.6402C14.3708 18.6176 15.2048 20.8116 17.0773 21.8626C18.2414 22.5159 19.5736 22.5965 20.7479 22.1972L20.182 20.1837ZM15.954 16.0466L15.9539 16.0467L15.954 16.0466Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9239 10.8362L20.793 14.8719L17.3999 14.2454L15.2158 9.74316L9.31534 11.837L8.85002 10.5257L7.30627 10.3355L8.46946 13.6136L12.53 12.5751L13.684 15.8269L10.877 19.9695L15.6405 24.0324L14.7376 25.0909L15.3448 26.5231L17.6021 23.8766L14.6725 20.8793L16.9117 18.2541L21.9028 18.6137L23.0396 12.4569L24.4078 12.7095L25.3447 11.4677L21.9239 10.8362ZM15.9986 16.1088V16.1089V16.1088Z",
    fill: "#FFEACF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBt);
export default __webpack_public_path__ + "static/media/BT.f6aa3d5e.svg";
export { ForwardRef as ReactComponent };